import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { InstitutionService } from 'src/app/services/institution.service';
import { ProjectService } from 'src/app/services/project.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-transfer-roles',
  templateUrl: './transfer-roles.component.html',
  styleUrls: ['./transfer-roles.component.scss'],
})
export class TransferRolesComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  currentUser;
  institutions = [];
  projects = [];

  constructor(
    private userService: UserService,
    private institutionService: InstitutionService,
    private projectService: ProjectService,
    private loadingService: LoadingService
  ) { }

  async ngOnInit() {
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;

          let institutionIDs = Object.keys(this.currentUser.institutionRoles).filter(id => u.institutionRoles[id].role === 'admin');
          institutionIDs.forEach(async id => {
            this.institutionService.getCurrentInstitution(id).subscribe((inst: any) => {
              if (inst) {
                this.institutions.push(inst[0]);
                this.institutionService.getInstitutionMembers(id).subscribe(members => {
                  if (members && members.length) {
                    this.institutions.filter(institution => institution.id === id)[0].members = members
                  }
                })
              }
            })
          })
          let projectIDs = Object.keys(this.currentUser.projectRoles).filter(id => u.projectRoles[id].role === 'admin');
          projectIDs.forEach(async id => {
            this.projectService.getCurrentProject(id).subscribe((inst: any) => {
              if (inst) {
                this.projects.push(inst[0]);
                this.projectService.getProjectMembers(id).subscribe(members => {
                  if (members && members.length) {
                    this.projects.filter(project => project.id === id)[0].members = members
                  }
                })
              }
            })
          })


        }
      })
    );
  }

  makeInstAdmin(u, i) {
    u.institutionRoles[i.id].role = 'admin';
    this.userService.saveUser(u.uid, u).then(() => { });
  }
  makeProjectAdmin(u, p) {
    u.projectRoles[p.id].role = 'admin';
    this.userService.saveUser(u.uid, u).then(() => { });
  }

  disableAccount() {
    this.loadingService.startLoading();
    this.currentUser.disabled = true;
    this.userService.saveUser(this.currentUser.uid, this.currentUser).then(() => {
      this.loadingService.stopLoading();
      this.userService.logout(true);
    });
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
